import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  path: {
    fill: 'white',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="268"
      height="198"
      viewBox="0 0 268 198"
      fill="none"
      className={classes.svg}
    >
      <path
        className={classes.path}
        d="M120.674 124.021H64.6416L90.872 42.6923V41.2042H94.1596V42.6687L120.674 124.021ZM184.724 195.027L113.034 1.21299C112.821 0.598831 112.23 0.197266 111.568 0.197266H71.8555V4.63811L0 195.027H41.5334L54.7313 154.753H130.513L145.745 195.027H184.724Z"
      />
      <path
        className={classes.path}
        d="M229.758 77.7695L260.931 37.6602C261.168 37.3295 261.31 36.9516 261.31 36.55V0.598097C261.31 0.385503 261.144 0.243774 260.931 0.243774L132.949 0.409125C132.783 0.409125 132.641 0.598097 132.712 0.763447L143.758 31.4005H226.328L219.422 36.6209L218.476 37.7074L178.929 89.2732C178.598 89.6983 178.503 90.2653 178.692 90.7613L185.859 110.745C186.45 112.399 188.224 113.107 189.738 112.233C195.32 109.092 202.085 107.745 209.204 109.115C220.533 111.312 229.19 119.792 231.461 131.107C235.008 148.752 222.165 164.271 205.396 165.311C204.805 165.334 204.213 165.405 203.622 165.405C198.655 165.405 193.972 164.13 189.927 161.886C189.927 161.886 202.865 197.908 202.912 197.956C207.666 198.145 212.279 197.719 216.725 196.893C245.841 191.483 267.909 166.043 267.909 135.382C267.909 109.517 252.204 87.3126 229.758 77.7695Z"
      />
    </svg>
  );
};
